// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__wv19e","errors":"Errors_errors__Xrat-"};